export default __webpack_public_path__ + "static/media/thrivingPetsPlusLogo-purple.37157eea.svg";